import { Link, useLocation } from "react-router-dom";
import {
  MdDeleteForever,
  MdOutlineSpaceDashboard,
  MdOutlineBusinessCenter,
  MdNotificationsNone,
  MdConnectWithoutContact,
  MdOutlineEmail,
  MdOutlineForum,
} from "react-icons/md";

import {
  PiUserSquare,
  PiFlagBannerFoldDuotone,
  PiContactlessPayment,
  PiMonitorPlayDuotone,
} from "react-icons/pi";

import { RiArchiveDrawerLine } from "react-icons/ri";

import { TbUserCheck, TbBusinessplan } from "react-icons/tb";

import Logo from "../../assets/Images/logo.png";

import { MENU } from "../../assets/constants/constants";

import { useEffect, useState } from "react";

import { BiDollar, BiPurchaseTag } from "react-icons/bi";
import { FaBlog, FaBullhorn, FaChartLine, FaComment, FaCreativeCommonsSampling, FaUserTie } from "react-icons/fa";

interface Props {
  collapsed: boolean;
  toggleSidebar: () => void;
}

const VerticalMenu = ({ collapsed, toggleSidebar }: Props) => {
  const URL = useLocation();

  const [active_menu, setActiveMenu] = useState(
    localStorage.getItem("active_menu") ?? MENU.DASHBOARD,
  );

  const PATH_TO_MENU: any = {
    "/dashboard": MENU.DASHBOARD,
    "/manage-entrepreneur": MENU.MANAGE_ENTERPRENEUR,
    "/manage-investor": MENU.MANAGE_INVESTOR,
    "/manage-mentors": MENU.MANAGE_MENTOR,
    "/mentor-payments": MENU.MENTOR_PAYMENTS,
    "/manage-subscription": MENU.MANAGE_SUBSCRIPTION,
    "/manage-banners": MENU.MANAGE_BANNER,
    "/manage-promotions": MENU.MANAGE_PROMOTION,
    "/manage-roles": MENU.MANAGE_ROLE,
    "/manage-users": MENU.MANAGE_USER,
    "/manage-transaction": MENU.MANAGE_TRANSACTION,
    "/manage-active-subscription": MENU.MANAGE_ACTIVE_SUBSCRIPTION,
    "/manage-customer-queries": MENU.MANAGE_CUSTOMER_QUERIES,
    "/manage-deactivated-accounts": MENU.MANAGE_DEACTIVATED_ACCOUNTS,
    "/manage-coupons": MENU.MANAGE_COUPONS,
    "/email-management": MENU.MANAGE_EMAIL,
    "/manage-sessions": MENU.MANAGE_SESSIONS,
  };

  const handleMenuClick = (menu: string) => {
    setActiveMenu(menu);

    localStorage.setItem("active_menu", menu);

    if (menu === MENU.MANAGE_ENTERPRENEUR || menu === MENU.MANAGE_INVESTOR) {
      localStorage.setItem("selectedTab", "request");
    }
  };

  useEffect(() => {
    const matchedMenu = PATH_TO_MENU[URL.pathname];

    if (matchedMenu) {
      setActiveMenu(matchedMenu);

      localStorage.setItem("active_menu", matchedMenu);
    }
  }, [URL.pathname]);

  return (
    <div
      id="vertical_menu"
      className={`verticle-menu ${collapsed ? "collapsed-menu" : ""}`}
    >
      {/* Logo */}
      <div className="text-center pb-3 position-relative">
        <img
          src={Logo}
          width={collapsed ? 55 : 118}
          alt=""
          className="transition-all"
        />
      </div>

      <div className="menu-list">
        {/* Dashboard */}
        <Link
          to={"/dashboard"}
          title="Dashboard"
          className={
            active_menu === MENU.DASHBOARD ? "active menu-item" : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.DASHBOARD)}
        >
          <MdOutlineSpaceDashboard className="menu-icon" />

          {!collapsed && <span className="nav-text">Dashboard</span>}
        </Link>

        {/* Entrepreneur */}
        <Link
          to={"/manage-entrepreneur"}
          title="Manage Entrepreneur"
          className={
            active_menu === MENU.MANAGE_ENTERPRENEUR
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_ENTERPRENEUR)}
        >
          <MdOutlineBusinessCenter className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Entrepreneur</span>}
        </Link>

        {/* Investor */}
        <Link
          to={"/manage-investor"}
          title="Manage Investors"
          className={
            active_menu === MENU.MANAGE_INVESTOR
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_INVESTOR)}
        >
          <TbBusinessplan className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Investors</span>}
        </Link>

        {/* Mentor */}
        <>
          <Link
            id="t-4"
            to={"/manage-mentors"}
            className={
              active_menu === MENU.MANAGE_MENTOR
                ? "active menu-item"
                : "menu-item"
            }
            onClick={() => handleMenuClick(MENU.MANAGE_MENTOR)}
          >
            <FaUserTie className="menu-icon" />

            {!collapsed && <span className="nav-text">Manage Mentors</span>}
          </Link>

          <Link
            id="t-4"
            to={"/mentor-payments"}
            className={
              active_menu === MENU.MENTOR_PAYMENTS
                ? "active menu-item"
                : "menu-item"
            }
            onClick={() => handleMenuClick(MENU.MENTOR_PAYMENTS)}
          >
            <PiContactlessPayment className="menu-icon" />
            {!collapsed && <span className="nav-text">Mentor Payments</span>}
          </Link>
        </>
        <Link
          to={"/email-management"}
          title="Email Management"
          className={
            active_menu === MENU.MANAGE_EMAIL ? "active menu-item" : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_EMAIL)}
        >
          <MdOutlineEmail className="menu-icon" />

          {!collapsed && <span className="nav-text">Email Management</span>}
        </Link>

        {/* Subscription */}
        <Link
          to={"/manage-subscription"}
          title="Manage Subscriptions"
          className={
            active_menu === MENU.MANAGE_SUBSCRIPTION
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_SUBSCRIPTION)}
        >
          <RiArchiveDrawerLine className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Subscriptions</span>}
        </Link>

        {/* Coupons */}
        <Link
          to={"/manage-coupons"}
          title="Manage Coupons"
          className={
            active_menu === MENU.MANAGE_COUPONS
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_COUPONS)}
        >
          <BiDollar className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Coupons</span>}
        </Link>

        {/* Banner */}
        <Link
          to={"/manage-banners"}
          title="Manage Banners"
          className={
            active_menu === MENU.MANAGE_BANNER
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_BANNER)}
        >
          <PiFlagBannerFoldDuotone className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Banners</span>}
        </Link>

        {/* Promotions */}
        <Link
          to={"/manage-promotions"}
          title="Manage Promotions"
          className={
            active_menu === MENU.MANAGE_PROMOTION
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_PROMOTION)}
        >
          <PiMonitorPlayDuotone className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Promotions</span>}
        </Link>
        <Link
          to={"/manage-forum-post"}
          title="Manage Investor Forum's Post"
          className={
            active_menu === MENU.INVESTOR_FORUM_POST
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.INVESTOR_FORUM_POST)}
        >
          <FaBullhorn className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Investor Forum's Post</span>}
        </Link>

        {/* Roles */}
        <Link
          to={"/manage-roles"}
          title="Manage Role"
          className={
            active_menu === MENU.MANAGE_ROLE ? "active menu-item" : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_ROLE)}
        >
          <PiUserSquare className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Role</span>}
        </Link>

        {/* Admin Users */}
        <Link
          to={"/manage-users"}
          title="Manage Admin Users"
          className={
            active_menu === MENU.MANAGE_USER ? "active menu-item" : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_USER)}
        >
          <TbUserCheck className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Admin Users</span>}
        </Link>

        {/* Transactions */}
        <Link
          to={"/manage-transaction"}
          title="Manage Transaction"
          className={
            active_menu === MENU.MANAGE_TRANSACTION
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_TRANSACTION)}
        >
          <MdNotificationsNone className="menu-icon" />

          {!collapsed && <span className="nav-text">Manage Transaction</span>}
        </Link>

        {/* Active Subscriptions */}
        <Link
          to={"/manage-active-subscription"}
          title="Manage Active Subscription"
          className={
            active_menu === MENU.MANAGE_ACTIVE_SUBSCRIPTION
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_ACTIVE_SUBSCRIPTION)}
        >
          <BiPurchaseTag className="menu-icon" />

          {!collapsed && (
            <span className="nav-text">Manage Active Subscription</span>
          )}
        </Link>
        <Link
          to={"/manage-chatbot-sessions"}
          title="Manage Chatbot Sessions"
          className={
            active_menu === MENU.MANAGE_SESSIONS
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_SESSIONS)}
        >
          <MdOutlineForum className="menu-icon" />

          {!collapsed && (
            <span className="nav-text">Manage Chatbot Sessions</span>
          )}
        </Link>
        {/* Customer Queries */}
        <Link
          to={"/manage-customer-queries"}
          title="Manage Customer Queries"
          className={
            active_menu === MENU.MANAGE_CUSTOMER_QUERIES
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_CUSTOMER_QUERIES)}
        >
          <MdConnectWithoutContact className="menu-icon" />

          {!collapsed && (
            <span className="nav-text">Manage Customer Queries</span>
          )}
        </Link>

        {/* Deleted Accounts */}
        <Link
          to={"/manage-deactivated-accounts"}
          title="Manage Deleted Accounts"
          className={
            active_menu === MENU.MANAGE_DEACTIVATED_ACCOUNTS
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_DEACTIVATED_ACCOUNTS)}
        >
          <MdDeleteForever className="menu-icon" />

          {!collapsed && (
            <span className="nav-text">Manage Deleted Accounts</span>
          )}
        </Link>
      </div>
    </div>
  );
};

export default VerticalMenu;
